import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './SwitchControl.styles';

const SwitchControl = ({ id, name, label, value, onChange, disabled, classes }) => (
  <FormControlLabel
    className={classes.labelContainer}
    classes={{ label: classes.label }}
    control={
      <Switch
        id={id}
        name={name}
        value={value}
        checked={value}
        onChange={() => onChange({ name, value: !value })}
        disabled={disabled}
        classes={{
          root: classes.root,
          switchBase: classes.benchSwitchBase,
          track: classes.benchBar,
          thumb: classes.benchIcon,
          checked: classes.benchChecked,
        }}
      />
    }
    label={label}
    labelPlacement="top"
    disabled={disabled}
  />
);

SwitchControl.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  label: PropTypes.any.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

SwitchControl.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(SwitchControl);
